export * from './checkbox';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/@angular/material/checkbox/index.js
// module id = ../../../material/checkbox/index.js
// module chunks = 3